import { Box, Tooltip } from '@/ui/primitives';
import { Button } from '@/ui/primitives/Button';
import { UploadFileIcon } from '@/ui/primitives/icons';
import type { ReactElement } from 'react';

type ExecutionRunsUploadActionProps = {
  disabledReason: string | null;
  onClick: () => void;
};

const ExecutionRunsUploadAction = ({
  disabledReason,
  onClick,
}: ExecutionRunsUploadActionProps): ReactElement => {
  return (
    <Tooltip title={disabledReason ?? ''} disableHoverListener={disabledReason === null}>
      <Box component="span">
        <Button
          startIcon={<UploadFileIcon />}
          fullWidthOnMobile={false}
          disabled={disabledReason !== null}
          onClick={onClick}
        >
          Upload Results Files
        </Button>
      </Box>
    </Tooltip>
  );
};

export { ExecutionRunsUploadAction };
